var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create-Asset-Flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-Studio-Custom-Copy-9",
    transform: "translate(-311.000000, -638.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Slide-in-panel",
    transform: "translate(104.100301, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(58.902144, 592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-6",
    transform: "translate(0.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keyword",
    transform: "translate(2.997555, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(145.000000, 7.200000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F98522",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(8.000000, 8.000000) rotate(-45.000000) translate(-8.000000, -8.000000) ",
    points: "12.8 6.93333333 9.06666667 6.93333333 9.06666667 3.2 6.93333333 3.2 6.93333333 6.93333333 3.2 6.93333333 3.2 9.06666667 6.93333333 9.06666667 6.93333333 12.8 9.06666667 12.8 9.06666667 9.06666667 12.8 9.06666667"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCross);
export default __webpack_public_path__ + "static/media/RemoveCross.a8babdc9.svg";
export { ForwardRef as ReactComponent };